<template>
  <component
    :is="componentMap[component.type]"
    v-for="(component, i) in components"
    :key="i"
    v-bind="removeType(component)"
    @change="$emit('change', component.label, $event)"
  />
</template>

<script lang="ts" setup>
import { LegendComponent, componentMap } from '.'

export type LegendProps = {
  components: LegendComponent[]
}

type Emit = {
  (e: 'change', label: string, checked: boolean): void
}

defineProps<LegendProps>()
defineEmits<Emit>()

function removeType<T, O extends { type: T }>(x: O): Omit<O, 'type'> {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { type, ...rest } = x
  return rest
}
</script>
